var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a = require('./tokens'), sparqlTokenMap = _a.sparqlTokenMap, stardogSparqlTokens = _a.stardogSparqlTokens;
import { BaseSparqlParser } from './BaseSparqlParser';
import { Parser } from 'chevrotain';
var StardogSparqlParser = /** @class */ (function (_super) {
    __extends(StardogSparqlParser, _super);
    function StardogSparqlParser(options, tokens, shouldSkipAnalysis) {
        if (tokens === void 0) { tokens = stardogSparqlTokens; }
        var _this = _super.call(this, options, tokens) || this;
        _this.ValidateQuery = _this.RULE('ValidateQuery', function () {
            _this.CONSUME(sparqlTokenMap.VALIDATE);
            _this.OR([
                { ALT: function () { return _this.CONSUME(sparqlTokenMap.ALL); } },
                { ALT: function () { return _this.SUBRULE(_this.MultiGraphRef); } },
                {
                    ALT: function () {
                        _this.AT_LEAST_ONE(function () { return _this.SUBRULE1(_this.iri); });
                        _this.OPTION(function () { return _this.SUBRULE2(_this.MultiGraphRef); });
                    },
                },
            ]);
            _this.OPTION1(function () { return _this.SUBRULE3(_this.UsingShapesClause); });
            _this.OPTION2(function () { return _this.SUBRULE4(_this.LimitClause); });
            _this.OPTION3(function () { return _this.SUBRULE5(_this.LimitPerShapeClause); });
        });
        _this.MultiGraphRef = _this.RULE('MultiGraphRef', function () {
            _this.CONSUME(sparqlTokenMap.GRAPH);
            _this.AT_LEAST_ONE(function () { return _this.SUBRULE(_this.iri); });
        });
        _this.UsingShapesClause = _this.RULE('UsingShapesClause', function () {
            _this.CONSUME(sparqlTokenMap.USING);
            _this.CONSUME(sparqlTokenMap.SHAPES);
            _this.OR([
                { ALT: function () { return _this.AT_LEAST_ONE(function () { return _this.SUBRULE(_this.iri); }); } },
                { ALT: function () { return _this.SUBRULE1(_this.MultiGraphRef); } },
                { ALT: function () { return _this.SUBRULE2(_this.QuadData); } },
            ]);
        });
        _this.LimitPerShapeClause = _this.RULE('LimitPerShapeClause', function () {
            _this.CONSUME(sparqlTokenMap.LIMIT);
            _this.CONSUME(sparqlTokenMap.PER);
            _this.CONSUME(sparqlTokenMap.SHAPE);
            _this.CONSUME(sparqlTokenMap.INTEGER);
        });
        _this.Query = _this.OVERRIDE_RULE('Query', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.SelectQuery); } },
                { ALT: function () { return _this.SUBRULE(_this.ConstructQuery); } },
                { ALT: function () { return _this.SUBRULE(_this.DescribeQuery); } },
                { ALT: function () { return _this.SUBRULE(_this.AskQuery); } },
                { ALT: function () { return _this.SUBRULE(_this.PathQuery); } },
                { ALT: function () { return _this.SUBRULE(_this.ValidateQuery); } },
            ]);
            _this.SUBRULE(_this.ValuesClause);
        });
        _this.PathQuery = _this.RULE('PathQuery', function () {
            _this.SUBRULE(_this.PathSpec);
            _this.MANY(function () { return _this.SUBRULE(_this.DatasetClause); });
            _this.CONSUME(sparqlTokenMap.START);
            _this.SUBRULE(_this.PathTerminal);
            _this.CONSUME(sparqlTokenMap.END);
            _this.SUBRULE1(_this.PathTerminal);
            _this.SUBRULE(_this.Via);
            _this.OPTION(function () { return _this.SUBRULE(_this.MaxLength); });
            _this.SUBRULE(_this.SolutionModifier);
        });
        _this.Via = _this.RULE('Via', function () {
            _this.CONSUME(sparqlTokenMap.VIA);
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.GroupGraphPattern); } },
                { ALT: function () { return _this.SUBRULE(_this.Var); } },
                { ALT: function () { return _this.SUBRULE(_this.Path); } },
            ]);
        });
        _this.PathTerminal = _this.RULE('PathTerminal', function () {
            _this.SUBRULE(_this.Var);
            _this.OPTION(function () {
                _this.OR([
                    {
                        ALT: function () {
                            _this.CONSUME(sparqlTokenMap.Equals);
                            _this.SUBRULE(_this.Constant);
                        },
                    },
                    { ALT: function () { return _this.SUBRULE(_this.GroupGraphPattern); } },
                ]);
            });
        });
        _this.PathSpec = _this.RULE('PathSpec', function () {
            _this.OR([
                { ALT: function () { return _this.CONSUME(sparqlTokenMap.PATHS); } },
                { ALT: function () { return _this.CONSUME(sparqlTokenMap.PATHS_SHORTEST); } },
                { ALT: function () { return _this.CONSUME(sparqlTokenMap.PATHS_ALL); } },
            ]);
            _this.OPTION1(function () { return _this.CONSUME(sparqlTokenMap.CYCLIC); });
        });
        _this.GraphPatternNotTriples = _this.OVERRIDE_RULE('GraphPatternNotTriples', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.GroupOrUnionGraphPattern); } },
                { ALT: function () { return _this.SUBRULE(_this.OptionalGraphPattern); } },
                { ALT: function () { return _this.SUBRULE(_this.MinusGraphPattern); } },
                { ALT: function () { return _this.SUBRULE(_this.GraphGraphPattern); } },
                { ALT: function () { return _this.SUBRULE(_this.ServiceGraphPattern); } },
                { ALT: function () { return _this.SUBRULE(_this.Filter); } },
                { ALT: function () { return _this.SUBRULE(_this.Bind); } },
                { ALT: function () { return _this.SUBRULE(_this.Unnest); } },
                { ALT: function () { return _this.SUBRULE(_this.InlineData); } },
            ]);
        });
        _this.TriplesSameSubject = _this.OVERRIDE_RULE('TriplesSameSubject', function () {
            _this.OR([
                {
                    ALT: function () {
                        _this.SUBRULE(_this.VarOrTerm);
                        _this.SUBRULE(_this.PropertyListNotEmpty);
                    },
                },
                {
                    ALT: function () {
                        // NOTE: Intentionally does not conform to the SPARQL* spec.
                        // Stardog does not allow nesting of embedded triples.
                        _this.SUBRULE(_this.EmbeddedTriplePattern);
                        _this.SUBRULE1(_this.PropertyListNotEmpty, { ARGS: [true] });
                    },
                },
                {
                    ALT: function () {
                        _this.SUBRULE(_this.TriplesNode);
                        _this.SUBRULE(_this.PropertyList);
                    },
                },
            ]);
        });
        // NOTE: Intentionally does not conform to the SPARQL* spec.
        // Stardog does not allow embedded triples with object lists.
        _this.PropertyListNotEmpty = _this.OVERRIDE_RULE('PropertyListNotEmpty', function (disallowEdgeProperties) {
            _this.SUBRULE(_this.Verb);
            _this.OR([
                {
                    ALT: function () {
                        _this.SUBRULE(_this.ObjectList);
                    },
                },
                {
                    GATE: function () { return !disallowEdgeProperties; },
                    ALT: function () {
                        _this.SUBRULE(_this.EmbeddedPropertyList);
                        _this.SUBRULE(_this.Object);
                    },
                },
            ]);
            _this.MANY(function () {
                _this.CONSUME(sparqlTokenMap.Semicolon);
                _this.OPTION(function () {
                    _this.SUBRULE1(_this.Verb);
                    _this.OR1([
                        {
                            ALT: function () {
                                _this.SUBRULE1(_this.ObjectList);
                            },
                        },
                        {
                            GATE: function () { return !disallowEdgeProperties; },
                            ALT: function () {
                                _this.SUBRULE1(_this.EmbeddedPropertyList);
                                _this.SUBRULE1(_this.Object);
                            },
                        },
                    ]);
                });
            });
        });
        // NOTE: Intentionally does not conform to the SPARQL* spec.
        // Stardog does not allow nesting of embedded triples.
        _this.EmbeddedPropertyList = _this.RULE('EmbeddedPropertyList', function () {
            _this.CONSUME(sparqlTokenMap.LCurly);
            _this.SUBRULE(_this.PropertyListNotEmpty, { ARGS: [true] });
            _this.CONSUME(sparqlTokenMap.RCurly);
        });
        _this.Object = _this.OVERRIDE_RULE('Object', function () {
            _this.OR([
                {
                    ALT: function () { return _this.SUBRULE(_this.GraphNode); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.EmbeddedTriplePattern); },
                },
            ]);
        });
        _this.TriplesSameSubjectPath = _this.OVERRIDE_RULE('TriplesSameSubjectPath', function () {
            _this.OR([
                {
                    ALT: function () {
                        _this.SUBRULE(_this.VarOrTerm);
                        _this.SUBRULE(_this.PropertyListPathNotEmpty);
                    },
                },
                {
                    ALT: function () {
                        // NOTE: Intentionally does not conform to the SPARQL* spec.
                        // Stardog does not allow nesting of embedded triples.
                        _this.SUBRULE(_this.EmbeddedTriplePattern);
                        _this.SUBRULE1(_this.PropertyListPathNotEmpty, { ARGS: [true] });
                    },
                },
                {
                    ALT: function () {
                        _this.SUBRULE(_this.TriplesNodePath);
                        _this.SUBRULE(_this.PropertyListPath);
                    },
                },
            ]);
        });
        // NOTE: Intentionally does not conform to the SPARQL* spec.
        // Stardog does not allow embedded triples with paths or object lists.
        _this.PropertyListPathNotEmpty = _this.OVERRIDE_RULE('PropertyListPathNotEmpty', function (disallowEdgeProperties) {
            _this.OR([
                {
                    ALT: function () {
                        _this.OR1([
                            { ALT: function () { return _this.SUBRULE(_this.VerbPath); } },
                            { ALT: function () { return _this.SUBRULE1(_this.VerbSimple); } },
                        ]);
                        _this.SUBRULE(_this.ObjectListPath);
                    },
                },
                {
                    GATE: function () { return !disallowEdgeProperties; },
                    ALT: function () {
                        _this.SUBRULE(_this.Verb);
                        _this.SUBRULE(_this.EmbeddedPropertyListPath);
                        _this.SUBRULE(_this.ObjectPath);
                    },
                },
            ]);
            _this.MANY(function () {
                _this.CONSUME(sparqlTokenMap.Semicolon);
                _this.OPTION(function () {
                    _this.OR2([
                        {
                            ALT: function () {
                                _this.OR3([
                                    { ALT: function () { return _this.SUBRULE1(_this.VerbPath); } },
                                    { ALT: function () { return _this.SUBRULE2(_this.VerbSimple); } },
                                ]);
                                _this.SUBRULE1(_this.ObjectListPath);
                            },
                        },
                        {
                            GATE: function () { return !disallowEdgeProperties; },
                            ALT: function () {
                                _this.SUBRULE1(_this.Verb);
                                _this.SUBRULE1(_this.EmbeddedPropertyListPath);
                                _this.SUBRULE1(_this.ObjectPath);
                            },
                        },
                    ]);
                });
            });
        });
        // NOTE: Intentionally does not conform to the SPARQL* spec.
        // Stardog does not allow nesting of embedded triples.
        _this.EmbeddedPropertyListPath = _this.RULE('EmbeddedPropertyListPath', function () {
            _this.CONSUME(sparqlTokenMap.LCurly);
            _this.SUBRULE(_this.PropertyListPathNotEmpty, { ARGS: [true] });
            _this.CONSUME(sparqlTokenMap.RCurly);
        });
        _this.GraphNodePath = _this.OVERRIDE_RULE('GraphNodePath', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.VarOrTermOrEmbeddedTriplePattern); } },
                { ALT: function () { return _this.SUBRULE(_this.TriplesNodePath); } },
            ]);
        });
        // NOTE: Intentionally does not conform to the SPARQL* spec. Stardog does not
        // allow nesting of embedded triples.
        _this.EmbeddedTriplePattern = _this.RULE('EmbeddedTriplePattern', function () {
            _this.CONSUME(sparqlTokenMap.LEmbed);
            _this.SUBRULE(_this.VarOrBlankNodeOrIriOrLit);
            _this.SUBRULE(_this.Verb);
            _this.SUBRULE1(_this.VarOrBlankNodeOrIriOrLit);
            _this.CONSUME(sparqlTokenMap.REmbed);
        });
        _this.VarOrTermOrEmbeddedTriplePattern = _this.RULE('VarOrTermOrEmbeddedTriplePattern', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.Var); } },
                { ALT: function () { return _this.SUBRULE(_this.GraphTerm); } },
                { ALT: function () { return _this.SUBRULE(_this.EmbeddedTriplePattern); } },
            ]);
        });
        _this.Bind = _this.OVERRIDE_RULE('Bind', function () {
            _this.CONSUME(sparqlTokenMap.BIND);
            _this.CONSUME(sparqlTokenMap.LParen);
            _this.SUBRULE(_this.ExpressionOrEmbeddedTriplePattern);
            _this.CONSUME(sparqlTokenMap.AS);
            _this.SUBRULE(_this.Var);
            _this.CONSUME(sparqlTokenMap.RParen);
        });
        _this.ExpressionOrEmbeddedTriplePattern = _this.RULE('ExpressionOrEmbeddedTriplePattern', function () {
            _this.OR([
                {
                    ALT: function () { return _this.SUBRULE(_this.Expression); },
                },
                {
                    ALT: function () { return _this.SUBRULE(_this.EmbeddedTriplePattern); },
                },
            ]);
        });
        // NOTE: This is nearly equivalent to VarOrTerm, but excludes NIL.
        _this.VarOrBlankNodeOrIriOrLit = _this.RULE('VarOrBlankNodeOrIriOrLit', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.Var); } },
                { ALT: function () { return _this.SUBRULE(_this.BlankNode); } },
                { ALT: function () { return _this.SUBRULE(_this.iri); } },
                { ALT: function () { return _this.SUBRULE(_this.RDFLiteral); } },
                { ALT: function () { return _this.SUBRULE(_this.NumericLiteral); } },
                { ALT: function () { return _this.SUBRULE(_this.BooleanLiteral); } },
            ]);
        });
        _this.Unnest = _this.RULE('Unnest', function () {
            _this.CONSUME(sparqlTokenMap.UNNEST);
            _this.CONSUME(sparqlTokenMap.LParen);
            _this.SUBRULE(_this.Expression);
            _this.CONSUME(sparqlTokenMap.AS);
            _this.SUBRULE(_this.Var);
            _this.CONSUME(sparqlTokenMap.RParen);
        });
        _this.BuiltInCall = _this.OVERRIDE_RULE('BuiltInCall', function () {
            _this.OR([
                { ALT: function () { return _this.SUBRULE(_this.Aggregate); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_STR); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_LANG); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_LANGMATCHES); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_DATATYPE); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_BOUND); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_IRI); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_URI); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_BNODE); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_RAND); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_ABS); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_CEIL); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_FLOOR); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_ROUND); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_CONCAT); } },
                { ALT: function () { return _this.SUBRULE(_this.SubstringExpression); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_STRLEN); } },
                { ALT: function () { return _this.SUBRULE(_this.StrReplaceExpression); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_UCASE); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_LCASE); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_ENCODE_FOR_URI); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_CONTAINS); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_STRSTARTS); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_STRENDS); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_STRBEFORE); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_STRAFTER); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_YEAR); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_MONTH); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_DAY); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_HOURS); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_MINUTES); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_SECONDS); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_TIMEZONE); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_TZ); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_NOW); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_UUID); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_STRUUID); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_MD5); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_SHA1); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_SHA256); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_SHA384); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_SHA512); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_COALESCE); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_IF); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_STRLANG); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_STRDT); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_sameTerm); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_isIRI); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_isURI); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_isBLANK); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_isLITERAL); } },
                { ALT: function () { return _this.SUBRULE(_this.BuiltInCall_isNUMERIC); } },
                { ALT: function () { return _this.SUBRULE(_this.RegexExpression); } },
                { ALT: function () { return _this.SUBRULE(_this.ExistsFunction); } },
                { ALT: function () { return _this.SUBRULE(_this.NotExistsFunction); } },
                // Stardog has some additional built-in functions, and supports user-defined custom functions
                { ALT: function () { return _this.SUBRULE(_this.StardogOrCustomFunction); } },
            ]);
        });
        _this.StardogOrCustomFunction = _this.RULE('StardogOrCustomFunction', function () {
            _this.CONSUME(sparqlTokenMap.UNKNOWN);
            _this.SUBRULE(_this.ExpressionList);
        });
        _this.ConstructTemplate = _this.OVERRIDE_RULE('ConstructTemplate', function () {
            _this.CONSUME(sparqlTokenMap.LCurly);
            _this.OPTION(function () {
                // Stardog supports the request of Quads in a Construct template. See Stardog issue #675
                return _this.SUBRULE(_this.Quads);
            });
            _this.CONSUME(sparqlTokenMap.RCurly);
        });
        if (!shouldSkipAnalysis) {
            Parser.performSelfAnalysis(_this);
        }
        return _this;
    }
    return StardogSparqlParser;
}(BaseSparqlParser));
export { StardogSparqlParser };
